import React from "react";
import { PaymentsAutoCollectFilterValue } from "../../../../../Contracts/Settings";
import { ReactComponent as KebabMenuIcon } from "../../../../../Assets/ActionIcons/KebabMenuIcon.svg";
import { useAuth0 } from "@auth0/auth0-react";
import { useSettingsStore } from "../../../../../Store/Settings";
import Dropdown from "../../../../../Components/Atoms/Dropdown";

export interface CustomFieldsListActionsProps {
  filter: PaymentsAutoCollectFilterValue;
}

const CustomFieldsListActions: React.FC<CustomFieldsListActionsProps> = ({ filter }) => {
  const { getAccessTokenSilently } = useAuth0();
  const { deletePaymentAutoCollectFilterValues } = useSettingsStore();

  const handleDeleteFilter = async () => {
    if (window.confirm("Are you sure you want to delete this filter?")) {
      await deletePaymentAutoCollectFilterValues(getAccessTokenSilently, filter.id);
    }
  };

  return (
    <div>
      <Dropdown
        autoFitBottomOffset={80}
        options={[
          {
            label: "Delete Custom Filter",
            value: "delete"
          }
        ]}
        onChange={handleDeleteFilter}
        position="bottom-right"
        anchor={
          <div className="cursor-pointer flex flex-col items-center">
            <KebabMenuIcon className="text-blue-600" />
            <div className="text-blue-600">More</div>
          </div>
        }
      />
    </div>
  );
};

export default CustomFieldsListActions;
